var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriceTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0039 3.75H24.4023C24.1038 3.74978 23.8173 3.86775 23.6055 4.07813L4.41015 23.2734C3.98985 23.6958 3.7539 24.2674 3.7539 24.8633C3.7539 25.4591 3.98985 26.0308 4.41015 26.4531L13.5508 35.5938C13.9731 36.0141 14.5448 36.25 15.1406 36.25C15.7365 36.25 16.3081 36.0141 16.7305 35.5938L35.918 16.4063C36.1283 16.1944 36.2463 15.9079 36.2461 15.6094V6C36.2475 5.70478 36.1906 5.41219 36.0785 5.13907C35.9664 4.86594 35.8015 4.61768 35.5931 4.40856C35.3847 4.19944 35.137 4.0336 34.8643 3.92058C34.5915 3.80756 34.2991 3.74959 34.0039 3.75Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 12.5C29.5055 12.5 29.0222 12.3534 28.6111 12.0787C28.2 11.804 27.8795 11.4135 27.6903 10.9567C27.5011 10.4999 27.4516 9.99723 27.548 9.51228C27.6445 9.02732 27.8826 8.58187 28.2322 8.23223C28.5819 7.8826 29.0273 7.6445 29.5123 7.54804C29.9972 7.45157 30.4999 7.50108 30.9567 7.6903C31.4135 7.87952 31.804 8.19995 32.0787 8.61108C32.3534 9.0222 32.5 9.50555 32.5 10C32.5 10.663 32.2366 11.2989 31.7678 11.7678C31.2989 12.2366 30.663 12.5 30 12.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceTag);
export default __webpack_public_path__ + "static/media/price-tag.d3e59d89332456d659c13afa748ac236.svg";
export { ForwardRef as ReactComponent };